import { Modality } from '../../api/client'
import Badge from './Badge'

/**
 * Lower-case modality keys, as the wireframe fixtures hold them. The generated
 * GraphQL enum is upper case, so the pill accepts either and normalises.
 */
export type ModalityKey = 'text' | 'image'

const LABELS: Record<ModalityKey, string> = { text: 'Text', image: 'Image' }

// Modality is minor metadata, so it takes the neutral tone — the label does the
// distinguishing, leaving colour meaningful for status and actions.
export default function ModalityPill({ modality }: { modality: Modality | ModalityKey }) {
    const key = modality.toLowerCase() as ModalityKey
    return (
        <Badge tone="neutral" size="small">
            {LABELS[key] ?? modality}
        </Badge>
    )
}
